import axios from 'axios'


const request = function (options) {
  const client =  axios.create({ baseURL: 'http://localhost:3000', headers: { 'Authorization': 'Bearer XXX' }})
  return client(options).then((response) => {
    console.debug('Request Successful!', response);
    return response.data;
  })
}

function getToken(email, password) {
  return request({
    method: "post",
    url: `/api/m1/get_token`,
    data: { email: email, password: password }
  })
}

const LMTestService = {
  getToken
};

export default LMTestService;
